import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { LoadingAction } from '../../shared/models/loading-action.enum';
import { BaseTag, Tag } from '../models/tag.model';
import { getCustomEvent } from '../../core/utils/http-request-utils';
import { HttpOptions } from '../../core/models/http-options.model';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private NAMESPACE = 'tag';

  constructor(private apiService: ApiService) {
  }

  public getCustomerTags(customerId: string): Observable<BaseTag[]> {
    return this.apiService.get<BaseTag[]>(`/customers/${customerId}/tags`);
  }

  public getCustomerBillerTags(customerBillerId: string): Observable<Tag[]> {
    return this.apiService.get<Tag[]>(`/customerBillers/${customerBillerId}/tags`);
  }

  public getSubAccountTags(subAccountId: string, customerBillerId: string): Observable<Tag[]> {
    return this.apiService.get<Tag[]>(
      `/customerBillers/${customerBillerId}/userpanel-access/sub-accounts/${subAccountId}/tags`,
    );
  }

  public assignToCustomerBiller(customerBillerId: string, tagId: string): Observable<void> {
    const param: HttpOptions = getCustomEvent(LoadingAction.CHANGE_CUSTOMER_BILLER_TAG,
      this.NAMESPACE, `${customerBillerId}#${tagId}`) as HttpOptions;
    return this.apiService.post(`/customerBillers/${customerBillerId}/tags/${tagId}`, null, param);
  }

  public assignNewTagToCustomerBiller(customerBillerId: string, tagName: string): Observable<void> {
    return this.apiService.post(`/customerBillers/${customerBillerId}/tags`, tagName);
  }

  public assignToSubAccount(customerBillerId: string, subAccountId: string, tagId: string): Observable<void> {
    const param: HttpOptions = getCustomEvent(LoadingAction.CHANGE_CUSTOMER_BILLER_TAG, this.NAMESPACE, `${customerBillerId}#${subAccountId}#${tagId}`) as HttpOptions;
    return this.apiService.post(
      `/customerBillers/${customerBillerId}/userpanel-access/sub-accounts/${subAccountId}/tags/${tagId}`,
      null, param,
    );
  }

  public assignNewTagToSubAccount(customerBillerId: string, subAccountId: string, tagName: string): Observable<void> {
    return this.apiService.post(
      `/customerBillers/${customerBillerId}/userpanel-access/sub-accounts/${subAccountId}/tags`,
      tagName,
    );
  }

  public deleteTagFromCustomerBiller(customerBillerId: string, tagId: string): Observable<void> {
    const param = getCustomEvent(LoadingAction.CHANGE_CUSTOMER_BILLER_TAG, this.NAMESPACE, `${customerBillerId}#${tagId}`);
    return this.apiService.delete(`/customerBillers/${customerBillerId}/tags/${tagId}`, null, param);
  }

  public deleteTagFromSubAccount(customerBillerId: string, subAccountId: string, tagId: string): Observable<void> {
    const param = getCustomEvent(LoadingAction.CHANGE_CUSTOMER_BILLER_TAG, this.NAMESPACE, `${customerBillerId}#${subAccountId}#${tagId}`);
    return this.apiService.delete(
      `/customerBillers/${customerBillerId}/userpanel-access/sub-accounts/${subAccountId}/tags/${tagId}`,
      null, param,
    );
  }

  public addCustomTag(customerId: string, tagName: string): Observable<BaseTag> {
    return this.apiService.post<BaseTag>(`/customers/${customerId}/tags`, { tagName });
  }

  public deleteTag(customerId: string, tag: Tag): Observable<unknown> {
    return this.apiService.delete(`/customers/${customerId}/tags/${tag.id}`);
  }

  public updateTag(customerId: string, tagId: string, tagName: string): Observable<BaseTag> {
    return this.apiService.put(`/customers/${customerId}/tags/${tagId}`, { tagName });
  }
}
